import React, {useState, useEffect} from 'react';
import { Box, DataTable,Button } from 'grommet';
import { Add } from 'grommet-icons';
import { withRouter } from 'react-router-dom';
import {TableLoadLayer, NavigationSnackBar } from '../../../components/utils/shared/shared';
import { APIRequest } from '../../../components/utils/shared/requests';
import { ShipmentSuccessNotification } from '../../../components/utils/shared/shipmentViewFunctions';

function AllCommodities(props){
    const [load, setLoad] = useState(true)
    const [commodities, setCommodities] = useState([]);
    const [commoditySucc,setCommoditySucc] = useState(props.location.commSucc)
        useEffect(() => { APIRequest('/commodities').then(result => {setCommodities(result); setLoad(false)})
        setTimeout(() => {
          setCommoditySucc(undefined);
        }, 5000)
        },[]);
    return(
    <Box>
        <NavigationSnackBar title={'Commodities'} user={props.user} pages={[{name: 'Dashboard',link: '/dashboard'}]}  />
        {commoditySucc && (<ShipmentSuccessNotification label={"Commodity"} edit={props.location.edit} />)}
      <Box direction='row' justify="end">
           <Button primary hoverIndicator label='Create Commodity' margin='small' icon={<Add />} onClick={() => props.history.push('/admin/commodities/new')}/>
        </Box>
        <Box margin={'small'} elevation='medium' round background={'background-front'} >
          <DataTable background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }, }} step={10} paginate margin='small'  columns={[ {header:"ID",property:"id", primary:true,sortable:true,search:false}, {header:"Name",property:"display_name",sortable:true,search:true}, {header:"Description",property:"description",sortable:false,search:false}, {header:"Commodity Code",property:"code",sortable:true,search:true}, ]} data={commodities} onClickRow={({datum}) => {props.history.push({pathname:`/admin/commodities/edit/${datum.id}`})}} />
          <TableLoadLayer load={load} label={'Loading Commodities...'} />
        </Box>
    </Box>
    )
}

export default withRouter(AllCommodities)